import script from "./ResultsHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./ResultsHeader.vue?vue&type=script&setup=true&lang=js"

import "./ResultsHeader.vue?vue&type=style&index=0&id=771aea00&scoped=true&lang=scss"

import exportComponent from "/opt/www/novasector.net/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-771aea00"]])

export default __exports__